import React from 'react';
import { TwitterTweetEmbed } from 'react-twitter-embed';

export const TwitterTweetEmbedInArticle: React.FC<{
    tweetId: string;
}> = (props) => {

    return (
        <>
            <TwitterTweetEmbed tweetId={props.tweetId} />  
        </>
  );
};